'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('aws-sdk');

var _TimeService = require('./util/TimeService.js');

var _TimeService2 = _interopRequireDefault(_TimeService);

var _UtilityService = require('./util/UtilityService.js');

var _UtilityService2 = _interopRequireDefault(_UtilityService);

var _LogService = require('./util/LogService.js');

var _LogService2 = _interopRequireDefault(_LogService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ts_instance = _TimeService2.default.ts_instance;
var us_instance = _UtilityService2.default.us_instance;
var ls_instance = _LogService2.default.ls_instance;

var DataCollector = function () {
	function DataCollector(config) {
		_classCallCheck(this, DataCollector);

		this.config = config;
		this.pageLoadID = us_instance.generateGUID();
		this.sendInterval = config.sendInterval || 4000;
		this.timeStamp = 0;
		this.batchSequence = 0;
		this.pageLoadData = null;
		this.additionalPageLoadData = {};
		this.multiplexArray = [];
		this.queuedData = [];
		this.pageLoadDataEventSent = false;
		this.suppressSubmission = false;
		this.kinesis = null;

		var _sendIntervalId = 0;
		var _dataToSend = [];
		var self = this;

		this.kinesis = new AWS.Kinesis({
			accessKeyId: this.config.accountKey,
			secretAccessKey: this.config.secretKey,
			region: this.config.region,
			httpOptions: {
				timeout: 30000
			},
			maxRetries: 1,
			retryDelayOptions: {
				base: 2000
			}
		});

		if (this.sendInterval > 0) {
			_sendIntervalId = global.setInterval(function () {
				if (self.queuedData.length === 0) {
					if (self.multiplexArray.length !== 0) {
						self.queuedData.push(self.multiplexArray.slice());
						_dataToSend = self.queuedData.slice();
					} else {
						_dataToSend = [];
					}
				} else {
					_dataToSend = self.queuedData.slice();
				}
				self.multiplexArray = [];
				self.queuedData = [];
				if (_dataToSend === undefined) return;
				if (_dataToSend.length === 0) return;
				self.submitEvents(_dataToSend);
			}, this.sendInterval);
		}
	}

	_createClass(DataCollector, [{
		key: 'getPageLoadID',
		value: function getPageLoadID() {
			return this.pageLoadID;
		}
	}, {
		key: 'sendPageLoadData',
		value: function sendPageLoadData(data) {
			try {
				if (this.pageLoadDataEventSent === true) return;
				this.pageLoadData = data;
				this.submitEvent(JSON.stringify(data));
				this.pageLoadDataEventSent = true;
			} catch (e) {
				console.error('[DataCollector] sendPageLoadData() - plid: ' + this.pageLoadID, e);
			}
		}
	}, {
		key: 'submitEvent',
		value: function submitEvent(data) {
			if (this.suppressSubmission === true) return;
			try {
				//data in as a json string so we parse here
				var d = JSON.parse(data);

				this.timeStamp = new Date().getTime();

				var dt = new Date(this.timeStamp + ts_instance.getTimeOffset());

				//final check to ensure date is valid
				if (dt && dt instanceof Date) {
					d.ts = dt.toISOString();
				} else {
					d.ts = new Date().getTime().toISOString();
				}

				//plid is the page load id associated with the page load
				//this could be sent in by the client
				//if this is the page load event, we wil not send in a plid
				//instead we will send in the eid with the value of the page load event id
				if (d.plid === undefined && d.T !== 'pl') {
					d.plid = this.pageLoadID;
				};
				//eid is the unique guid associated with the specific event being recorded.
				//if this is a page load event, the eid will be the plid
				if (d.T === 'pl') {
					d.eid = this.pageLoadID;
					this.pageLoadData = d;
				} else {
					d.eid = us_instance.generateGUID();
				}

				//if the client has set the batchInterval parameter
				//we will send the data in batches, else we will send one at a time.
				//we wont do any encoding here as it is done in the submitEvents method.
				if (this.sendInterval > 0) {
					var base64Bytes = us_instance.getBase64Length(JSON.stringify(this.multiplexArray));
					//There is a limit to the amount of data that can be sent in a batch
					//currently it is 50KB
					if (base64Bytes < 50000) {
						this.multiplexArray.push(d);
					} else {
						//we push new elements so that in the for loop we start with the oldest (FIFO)
						this.queuedData.push(this.multiplexArray.slice());
						this.multiplexArray = [];
						this.multiplexArray.push(d);
					}
				} else {
					//the AWS Buffer class will decode the data into an array of unsigned ints
					//AWS automatically converts to base64
					//when using proxy, we are responsible for converting to base64
					this.kinesis.putRecord({
						Data: new AWS.util.Buffer(JSON.stringify(d)) || '',
						PartitionKey: this.pageLoadID,
						StreamName: this.streamName
					}, function (err, data) {
						return err && console.error(err, data);
					});
				}
			} catch (err) {
				console.error(err);
			}
		}
	}, {
		key: 'submitEvents',
		value: function submitEvents(data) {
			if (this.suppressSubmission === true) return;
			var _batchId = us_instance.generateGUID();
			var _recordArray = [];
			var _records = [];
			this.batchSequence++;

			//data in as a json string
			try {
				for (var i in data) {
					var d = data[i];
					_records = [];

					for (var key in d) {

						//d will be a json array
						var ev = d[key];

						//plid is the page load id associated with the page load
						//this could be sent in by the client
						//if this is the page load event, we wil not send in a plid
						//instead we will send in the eid with the value of the page load event
						if (ev.plid === undefined && ev.T !== 'pl') {
							ev.plid = this.pageLoadID;
						};

						ev.bid = _batchId;
						ev.bs = this.batchSequence;

						//eid is the unique guid associated with the specific event being recorded.
						//if this is a page load event, the eid will be the plid
						//we are now NOT sending in pl events as they will be manufactured by the consumer
						if (ev.T === 'pl' && ev.eid !== undefined) {
							if (this.pageLoadData === undefined || this.pageLoadData === null) {
								this.pageLoadData = ev;
							}
							this.pageLoadData.T = 'pld';
							this.pageLoadData.plid = this.pageLoadID;
							this.pageLoadData.bid = _batchId;
							this.pageLoadData.bs = this.batchSequence;
						} else {
							if (ev.eid === undefined) ev.eid = us_instance.generateGUID();
							_records.push(ev);
						}
					}

					//now sending in a page load data event at the beginning of each batch
					//need to generate a new eid each time a batch is sent
					//need to include any additional page load data as inserted by adapter
					if (this.pageLoadData) {
						this.pageLoadData = Object.assign({}, this.pageLoadData, this.additionalPageLoadData);
						this.pageLoadData.eid = us_instance.generateGUID();
						this.pageLoadData.bs = this.batchSequence;
						this.pageLoadData.bid = _batchId;

						_records.unshift(this.pageLoadData);
					} else {
						//if we are here, page load data is undefined. Not good.
						console.error("[DataCollector] submitEvents() pageLoadData not defined for plid: " + this.pageLoadID);
					}
					_recordArray.push({ Data: new AWS.util.Buffer(JSON.stringify(_records)), PartitionKey: this.pageLoadID });
				}
				this.kinesis.putRecords({
					Records: _recordArray,
					StreamName: this.config.streamName
				}, function (err, data) {
					return err && console.error(err, data);
				});
			} catch (err) {
				console.error(err);
			}
		}
	}]);

	return DataCollector;
}();

exports.default = DataCollector;